module.exports = __webpack_public_path__ + "img/DOS_DEDO.4e16170d.png";